import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import _ from 'lodash';
import IMask from 'imask';

// Make lodash available globally for WooCommerce
window._ = _;

import './default.scss';
import './fonts.scss';

// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import './colors.scss';
import './woocommerce.scss';

import './style.scss';

// const swiper = new Swiper(...);

document.addEventListener('DOMContentLoaded', () => {
  
  const homepageSlider = document.querySelector('.homepage-slider');
  if (homepageSlider) {
    const swiperHomepage = new Swiper('.homepage-slider', {
      modules: [Navigation, Pagination],
      direction: 'horizontal',
      loop: true,

      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },

      navigation: {
        enabled: false,
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        768: {
          navigation: {
            enabled: true,
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        },
      },
    });
  }

  const productTabs = document.querySelector('.products__cats.tabs');
  if (productTabs) {
    const tabs = productTabs.querySelectorAll('a.product-category-link');
    const products = document.querySelectorAll('.products--all li.product');

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        tabs.forEach((t) => t.classList.remove('active'));
        tab.classList.add('active');
        console.log(tab.dataset.slug);
        products.forEach((p) => {
          p.classList.add('hidden');
          if (p.classList.contains(`product_cat-${tab.dataset.slug}`)) {
            p.classList.remove('hidden');
          }
        });
      });
    });
  }


});

jQuery(() => {
  // swatches
  document.querySelectorAll('.variations select').forEach((select) => {
    let values = Array.from(select.options).map((option) => {
      return {
        val: option.value,
        text: option.innerText,
      };
    });
    values = values.filter((value) => value.val !== '');
    select.insertAdjacentHTML(
      'afterend',
      `
      <div class="swatches">
        ${values
          .map(
            (value) => `
          <a class="swatches__option" data-value="${value.val}">${value.text}</a>
        `
          )
          .join('')}
      </div>
    `
    );
  });

  document.querySelectorAll('.swatches').forEach((swatch) => {
    const select = swatch.previousElementSibling;
    const options = swatch.querySelectorAll('.swatches__option');
    select.classList.add('hidden');
    options.forEach((option) => {
      option.addEventListener('click', (e) => {
        e.preventDefault();
        options.forEach((o) => o.classList.remove('active'));
        option.classList.add('active');
        select.value = option.dataset.value;
        jQuery(select).trigger("change");
        select.classList.add('hidden');
      });
    });
  });
})

// qty

document.addEventListener('DOMContentLoaded', () => {
  const qtys = document.querySelectorAll('.quantity');
  qtys.forEach((qty) => {
    const input = qty.querySelector('.input-text.qty');
    const plus = qty.querySelector('.qty__mod--inc');
    const minus = qty.querySelector('.qty__mod--dec');

    plus.addEventListener('click', () => {
      input.value = parseInt(input.value) + 1;
    });

    minus.addEventListener('click', () => {
      if (input.value > 1) {
        input.value = parseInt(input.value) - 1;
      }
    });
  });
});

// mobile burger

document.addEventListener('DOMContentLoaded', () => {
  let burger = document.querySelector('.mobile-menu__burger');
  let menuWrapper = document.querySelector('.mobile-menu__wrapper');
  let header = document.querySelector('.page-header');
  burger.addEventListener('click', (e) => {
    let stateOpened = menuWrapper.classList.contains('opened');
    toggleMobileMenu(stateOpened ? 'close' : 'open');
  });

  function toggleMobileMenu(action = 'open') {
    if (action === 'open') {
      burger.classList.add('opened');
      menuWrapper.classList.add('opened');
      menuWrapper.classList.remove('d-none');
      header.classList.add('opened');
    } else {
      burger.classList.remove('opened');
      menuWrapper.classList.remove('opened');
      menuWrapper.classList.add('d-none');
      header.classList.remove('opened');
    }
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const relatedSlider = document.querySelector('.related-slider');
  if (relatedSlider) {
    const swiperRelated = new Swiper('.related-slider', {
      modules: [Navigation],
      direction: 'horizontal',
      slidesPerView: 2.3,
      spaceBetween: 24,
      navigation: {
        enabled: false,
        nextEl: '.related-swiper-button-next',
        prevEl: '.related-swiper-button-prev',
      },
      breakpoints: {
        1024: { 
          slidesPerView: 4,
          navigation: {
            enabled: true,
            nextEl: '.related-swiper-button-next',
            prevEl: '.related-swiper-button-prev',
          },
        },
      },
    });
  }

  
});


// Header scroll effect and back-to-top button
document.addEventListener('scroll', () => {
  const header = document.querySelector('.page-header');
  const backToTopButton = document.querySelector('.back-to-top');
  
  // Header scroll effect
  if (window.scrollY > 0) {
    header.classList.add('scrolled');
  } else {
    header.classList.remove('scrolled');
  }
  
  // Back to top button visibility
  if (backToTopButton) {
    if (window.scrollY > 300) {
      backToTopButton.classList.add('show');
    } else {
      backToTopButton.classList.remove('show');
    }
  }
});

// Back to top button functionality
document.addEventListener('DOMContentLoaded', () => {
  const backToTopButton = document.querySelector('.back-to-top');
  
  if (backToTopButton) {
    backToTopButton.addEventListener('click', (e) => {
      e.preventDefault();
      
      // Smooth scroll to top
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  }
});

// WooCommerce Checkout: Hide delivery fields and set default value if pickup is selected
function handlePickupShippingFields() {
  // List of shipping address field wrappers to hide

  const isPickup = document.querySelector('.wc-block-checkout__shipping-method-option--selected .wc-block-checkout__shipping-method-option-title').textContent.toLowerCase().includes('самовывоз');

  
  console.log(isPickup);

  setTimeout(() => {
    const billingDiv = document.querySelector('.wc-block-checkout__billing-fields');

    billingDiv?.querySelectorAll('input').forEach((input) => {
      input.value = isPickup ? 'pickup' : '';
      input.dispatchEvent(new Event('change'));
    });
    billingDiv?.querySelectorAll('input#billing-postcode').forEach((input) => {
      input.value = isPickup ? '100000' : '';
      input.dispatchEvent(new Event('change'));
    });
  }, 300);
  // billingDiv.querySelector('input').value = isPickup ? 'pickup' : '';
  // billingDiv.style.display = isPickup ? 'none' : 'block';
}

// Setup observer for checkout changes
function setupCheckoutObserver() {
  const checkoutMain = document.querySelector('.wc-block-checkout__main');
  if (!checkoutMain) return;

  const observer = new MutationObserver((mutations) => {
    handlePickupShippingFields();
  });

  observer.observe(checkoutMain, {
    childList: true,
    subtree: true,
    attributes: true
  });
}

// disable animation on variant select
jQuery(document).on('show_variation', '.cart.variations_form', (e, variation) => {
  let hasText = !!jQuery.trim(jQuery('.woocommerce-variation.single_variation').text())
  jQuery('.woocommerce-variation.single_variation').stop().removeAttr('style').toggle(hasText)
  console.log('Variation selected:', variation);
}).on('hide_variation', (e) => {
  jQuery('.woocommerce-variation.single_variation').stop().hide()
  console.log('Variation hidden');
}).on('found_variation', '.cart.variations_form', (e, variation) => {
  console.log('Found variation:', variation);
})

// Custom Add to Cart Message Handling
document.addEventListener('DOMContentLoaded', () => {
  // Force all add to cart buttons to use AJAX for loop products only
  preventAddToCartPageReload();
  
  // Handle AJAX add to cart messages
  jQuery(document.body).on('added_to_cart removed_from_cart item_removed_from_classic_cart', (event, fragments, cart_hash, button) => {
    console.log('Cart Event:', event.type);
    
    // Remove any existing messages
    const existingMessages = document.querySelectorAll('.custom-add-to-cart-message');
    existingMessages.forEach(msg => msg.remove());
    
    // Only show message for add to cart events
    if (event.type === 'added_to_cart' && button) {
      // Get product name from button context
      let productName = 'Товар';
      
      // Try to get product name from the closest product container
      // Convert jQuery object to DOM element if needed
      const buttonElement = button.jquery ? button[0] : button;
      if (buttonElement) {
        const productContainer = buttonElement.closest('.product, .type-product');
        if (productContainer) {
          const titleElement = productContainer.querySelector('.woocommerce-loop-product__title, h2, h3, .product-title');
          if (titleElement) {
            productName = titleElement.textContent.trim();
          }
        }
      }
      
      // Create and show custom message
      showAddToCartMessage(productName);
    }
  });
  
  // Handle regular form submissions (non-AJAX) - PREVENT ALL PAGE RELOADS
  const addToCartForms = document.querySelectorAll('form.cart, form.variations_form, form.grouped_form');
  addToCartForms.forEach(form => {
    form.addEventListener('submit', (e) => {
      e.preventDefault(); // Always prevent default form submission
      
      // Handle AJAX add to cart
      handleAjaxAddToCart(form, e);
    });
  });
  
  // Handle existing success messages on page load
  const existingMessages = document.querySelectorAll('.woocommerce-message');
  if (existingMessages.length > 0) {
    existingMessages.forEach(message => {
      const text = message.textContent;
      const productMatch = text.match(/"([^"]+)"/);
      const productName = productMatch ? productMatch[1] : 'Товар';
      
      // Hide the original message
      message.style.display = 'none';
      
      // Show custom message
      showAddToCartMessage(productName);
    });
  }
});

// Function to prevent page reloads completely
function preventAddToCartPageReload() {
  // Only handle loop add to cart (product archives)
  document.addEventListener('click', (e) => {
    if (e.target.matches('.ajax_add_to_cart, .add_to_cart_button') && !e.target.matches('.single_add_to_cart_button')) {
      e.preventDefault();
      
      const button = e.target;
      const productId = button.getAttribute('data-product_id') || button.value;
      const quantity = button.getAttribute('data-quantity') || '1';
      
      if (productId) {
        // Handle loop add to cart
        handleLoopAddToCart(button, productId, quantity);
      }
    }
  });
}

// Handle loop add to cart (product archives)
function handleLoopAddToCart(button, productId, quantity) {
  // Show loading state
  const originalText = button.textContent;
  button.textContent = 'Добавляем...';
  button.disabled = true;
  
  // Get product name for message
  // Ensure we're working with a DOM element
  const buttonElement = button.jquery ? button[0] : button;
  const productContainer = buttonElement.closest('.product, .type-product');
  let productName = 'Товар';
  if (productContainer) {
    const titleElement = productContainer.querySelector('.woocommerce-loop-product__title, h2, h3, .product-title');
    if (titleElement) {
      productName = titleElement.textContent.trim();
    }
  }
  
  // Use jQuery AJAX (WooCommerce standard)
  const ajaxUrl = (typeof wc_add_to_cart_params !== 'undefined' && wc_add_to_cart_params.wc_ajax_url) 
    ? wc_add_to_cart_params.wc_ajax_url.toString().replace('%%endpoint%%', 'add_to_cart')
    : '/wp-admin/admin-ajax.php?action=woocommerce_add_to_cart';
    
  jQuery.ajax({
    type: 'POST',
    url: ajaxUrl,
    data: {
      product_id: productId,
      quantity: quantity
    },
    success: function(response) {
      // Restore button
      button.textContent = originalText;
      button.disabled = false;
      
      if (response.error && response.product_url) {
        window.location = response.product_url;
        return;
      }
      
      // Update fragments
      if (response.fragments) {
        jQuery.each(response.fragments, function(key, value) {
          jQuery(key).replaceWith(value);
        });
      }
      
      // Trigger added_to_cart event with proper data
      jQuery(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, jQuery(button)]);
      
      // Show custom message
      showAddToCartMessage(productName);
      
      // Force cart counter update
      if (window.cartCounterManager) {
        window.cartCounterManager.animateCartCounter();
      }
    },
    error: function() {
      // Restore button on error
      button.textContent = originalText;
      button.disabled = false;
      console.error('Add to cart failed');
    }
  });
}

// Handle form-based add to cart (single products)
function handleAjaxAddToCart(form, event) {
  const formData = new FormData(form);
  const productId = formData.get('variation_id') ||formData.get('add-to-cart') || formData.get('product_id') || form.querySelector('[name="add-to-cart"]')?.value;
  const variationId = formData.get('variation_id');
  const quantity = formData.get('quantity') || '1';
  
  // Get submit button
  const submitButton = form.querySelector('[type="submit"]');
  if (submitButton) {
    const originalText = submitButton.textContent;
    submitButton.textContent = 'Добавляем...';
    submitButton.disabled = true;
    
    // Restore button function
    const restoreButton = () => {
      submitButton.textContent = originalText;
      submitButton.disabled = false;
    };
    
    // Check for variable products
    if (form.classList.contains('variations_form') && (!variationId || variationId === '0')) {
      alert('Пожалуйста, выберите опции товара');
      restoreButton();
      return;
    }
    
    // Debug logging
    console.log('Add to cart data:', {
      productId: productId,
      variationId: variationId,
      quantity: quantity,
      isVariableProduct: form.classList.contains('variations_form'),
      formAction: form.action,
      wc_ajax_url: typeof wc_add_to_cart_params !== 'undefined' ? wc_add_to_cart_params.wc_ajax_url : 'undefined'
    });
    
    // Get product name
    const productName = getProductNameFromForm(form);
    
    // Prepare AJAX data
    const ajaxData = {
      product_id: productId,
      quantity: quantity
    };
    
    if (variationId && variationId !== '0') {
      ajaxData.variation_id = variationId;
      
      // Add variation attributes
      const attributes = {};
      form.querySelectorAll('[name^="attribute_"]').forEach(input => {
        console.log('Found attribute input:', input.name, '=', input.value);
        if (input.value && input.value !== '') {
          attributes[input.name] = input.value;
        }
      });
      Object.assign(ajaxData, attributes);
    }
    
    console.log('Final AJAX data being sent:', ajaxData);
    
    // Send AJAX request
    const ajaxUrl = (typeof wc_add_to_cart_params !== 'undefined' && wc_add_to_cart_params.wc_ajax_url) 
      ? wc_add_to_cart_params.wc_ajax_url.toString().replace('%%endpoint%%', 'add_to_cart')
      : (typeof woocommerce_params !== 'undefined' && woocommerce_params.ajax_url) 
        ? woocommerce_params.ajax_url + '?action=woocommerce_add_to_cart'
        : '/wp-admin/admin-ajax.php?action=woocommerce_add_to_cart';
        
    console.log('Using AJAX URL:', ajaxUrl);
      
    jQuery.ajax({
      type: 'POST',
      url: ajaxUrl,
      data: ajaxData,
      success: function(response) {
        console.log('AJAX response:', response);
        restoreButton();
        
        if (response.error && response.product_url) {
          console.log('Redirecting due to error:', response.error);
          console.log('Full error response:', response);
          // Temporarily disable redirect to debug
          // window.location = response.product_url;
          alert('Error: ' + JSON.stringify(response));
          return;
        }
        
        // Update fragments
        if (response.fragments) {
          jQuery.each(response.fragments, function(key, value) {
            jQuery(key).replaceWith(value);
          });
        }
        
        // Trigger added_to_cart event with proper data
        jQuery(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, jQuery(submitButton)]);
        
        // Show custom message
        showAddToCartMessage(productName);
        
        // Force cart counter update
        if (window.cartCounterManager) {
          window.cartCounterManager.animateCartCounter();
        }
      },
      error: function(xhr, status, error) {
        restoreButton();
        console.error('Add to cart failed:', {
          status: status,
          error: error,
          response: xhr.responseText
        });
        
        // Show user-friendly error message
        alert('Ошибка добавления в корзину. Попробуйте еще раз.');
      }
    });
  }
}

// Function to show custom add to cart message
function showAddToCartMessage(productName) {
  // Remove any existing messages first
  const existingMessages = document.querySelectorAll('.custom-add-to-cart-message');
  existingMessages.forEach(msg => msg.remove());
  
  // Create message element
  const messageDiv = document.createElement('div');
  messageDiv.className = 'custom-add-to-cart-message';
  
  const cartUrl = typeof wc_add_to_cart_params !== 'undefined' ? 
    wc_add_to_cart_params.cart_url : '/cart/';
  
  messageDiv.innerHTML = `
    <div class="message-content">
      <div class="message-icon"></div>
      <div class="message-text">
        <strong>${escapeHtml(productName)}</strong> добавлен в корзину!
      </div>
    </div>
  `;
  
  // Add to page
  document.body.appendChild(messageDiv);
  
  // Auto-remove after 5 seconds
  // setTimeout(() => {
  //   if (messageDiv.parentNode) {
  //     messageDiv.remove(); 
  //   }
  // }, 5000);
  
  // Add click outside to close
  setTimeout(() => {
    const clickOutsideHandler = (e) => {
      if (!messageDiv.contains(e.target)) {
        messageDiv.remove();
        document.removeEventListener('click', clickOutsideHandler);
      }
    };
    document.addEventListener('click', clickOutsideHandler);
  }, 100);
}

// Helper function to get product name from form
function getProductNameFromForm(form) {
  // Try to find product title in the same container
  const container = form.closest('.product, .type-product, .entry-summary, .summary');
  if (container) {
    const titleElement = container.querySelector('h1, .product_title, .entry-title');
    if (titleElement) {
      return titleElement.textContent.trim();
    }
  }
  
  // Fallback: try to find in the page
  const pageTitle = document.querySelector('.entry-title, h1.product_title');
  if (pageTitle) {
    return pageTitle.textContent.trim();
  }
  
  return 'Товар';
}

// Helper function to escape HTML
function escapeHtml(text) {
  const map = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;'
  };
  return text.replace(/[&<>"']/g, m => map[m]);
}

// Enhanced cart counter management system
class CartCounterManager {
  constructor() {
    this.init();
  }

  init() {
    // Listen for all WooCommerce cart events
    this.bindWooCommerceEvents();
    // Listen for manual cart updates (quantity changes, removals)
    this.bindCartPageEvents();
    // Initialize mutation observer for dynamic content
    this.initMutationObserver();
  }

  bindWooCommerceEvents() {
    // Standard WooCommerce fragment events
    jQuery(document.body).on('wc_fragments_refreshed wc_fragments_loaded', () => {
      this.animateCartCounter();
    });

    // Add to cart events
    jQuery(document.body).on('added_to_cart', (event, fragments, cart_hash, button) => {
      this.updateCartCounter(fragments);
      this.animateCartCounter();
    });

    // Remove from cart events
    jQuery(document.body).on('removed_from_cart item_removed_from_classic_cart', (event, fragments, cart_hash) => {
      this.updateCartCounter(fragments);
      this.animateCartCounter();
    });

    // Cart updated events
    jQuery(document.body).on('updated_wc_div updated_cart_totals', () => {
      this.refreshCartCounter();
    });
  }

  bindCartPageEvents() {
    // Quantity input changes on cart page
    jQuery(document).on('change', 'input.qty, .quantity input, .wc-block-cart-item__quantity input', _.debounce(() => {
      this.refreshCartCounter();
    }, 500));

    // Remove item links on cart page (both classic and block cart)
    jQuery(document).on('click', '.remove, .product-remove a, .wc-block-cart-item__remove-link', (e) => {
      // Wait for removal to process, then update counter
      setTimeout(() => {
        this.refreshCartCounter();
      }, 1000);
    });

    // Apply coupon / update cart buttons
    jQuery(document).on('click', '[name="apply_coupon"], [name="update_cart"], .wc-block-cart__submit-button', () => {
      setTimeout(() => {
        this.refreshCartCounter();
      }, 1500);
    });
    
    // Handle mini cart updates
    jQuery(document).on('click', '.woocommerce-mini-cart .remove', (e) => {
      setTimeout(() => {
        this.refreshCartCounter();
      }, 800);
    });
    
    // Handle quantity changes in mini cart
    jQuery(document).on('change', '.woocommerce-mini-cart .qty', _.debounce(() => {
      this.refreshCartCounter();
    }, 500));
  }

  initMutationObserver() {
    // Watch for dynamic cart changes
    const cartObserver = new MutationObserver(_.debounce((mutations) => {
      // Skip if we're currently updating to prevent infinite loops
      if (this.isUpdating) {
        return;
      }
      
      let shouldUpdate = false;
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          // Check if cart-related elements changed (but exclude counter updates)
          const target = mutation.target;
          
          // Skip if the mutation is just the cart counter being updated
          if (target.classList && target.classList.contains('cart-counter')) {
            return;
          }
          
          // Skip if parent is cart counter
          if (target.closest('.cart-counter')) {
            return;
          }
          
          // Only trigger for actual cart content changes
          if (target.closest('.woocommerce-cart, .cart_totals, .shop_table, .wc-block-cart, .woocommerce-mini-cart, .widget_shopping_cart')) {
            // Check if added/removed nodes are cart items, not just counter updates
            const hasCartItems = Array.from(mutation.addedNodes).some(node => 
              node.nodeType === 1 && node.matches && 
              node.matches('.cart_item, .wc-block-cart-item, .woocommerce-cart-form__cart-item')
            ) || Array.from(mutation.removedNodes).some(node => 
              node.nodeType === 1 && node.matches && 
              node.matches('.cart_item, .wc-block-cart-item, .woocommerce-cart-form__cart-item')
            );
            
            if (hasCartItems) {
              shouldUpdate = true;
            }
          }
        }
      });
      
      if (shouldUpdate) {
        this.refreshCartCounter();
      }
    }, 500));

    // Only observe cart and checkout pages to reduce overhead
    if (document.querySelector('.woocommerce-cart, .woocommerce-checkout, .wc-block-cart')) {
      cartObserver.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: false
      });
    }
  }

  updateCartCounter(fragments) {
    // Set updating flag to prevent observer loops
    this.isUpdating = true;
    
    if (fragments && fragments['.cart-counter']) {
      const cartCounters = document.querySelectorAll('.cart-counter');
      cartCounters.forEach(counter => {
        counter.outerHTML = fragments['.cart-counter'];
      });
    }
    
    if (fragments && fragments['.cart-total']) {
      const cartTotals = document.querySelectorAll('.cart-total');
      cartTotals.forEach(total => {
        total.outerHTML = fragments['.cart-total'];
      });
    }
    
    // Clear updating flag after a brief delay
    setTimeout(() => {
      this.isUpdating = false;
    }, 100);
  }

  refreshCartCounter() {
    // Manual AJAX call to update cart counter
    if (typeof wc_add_to_cart_params === 'undefined') {
      return;
    }

    // Throttle requests to prevent spam
    if (this.refreshTimeout) {
      clearTimeout(this.refreshTimeout);
    }
    
    this.refreshTimeout = setTimeout(() => {
      jQuery.ajax({
        url: wc_add_to_cart_params.ajax_url,
        type: 'POST',
        data: {
          action: 'update_cart_counter',
          nonce: wc_add_to_cart_params.cart_counter_nonce
        },
        success: (response) => {
          if (response.success && response.data.fragments) {
            this.updateCartCounter(response.data.fragments);
            this.animateCartCounter();
          }
        },
        error: (xhr, status, error) => {
          console.log('Cart counter update failed:', error);
        }
      });
    }, 200);
  }

  animateCartCounter() {
    const cartCounters = document.querySelectorAll('.cart-counter');
    cartCounters.forEach(counter => {
      // Add animation class
      counter.classList.add('updating');
      
      setTimeout(() => {
        counter.classList.remove('updating');
      }, 200);
    });
  }
}

// Initialize cart counter manager and make it globally accessible
document.addEventListener('DOMContentLoaded', () => {
  window.cartCounterManager = new CartCounterManager();
});

// Additional cart counter support for WooCommerce Blocks and cart page
jQuery(document).ready(() => {
  // Handle cart page quantity updates
  jQuery(document).on('change', '.woocommerce-cart-form input.qty', function() {
    setTimeout(() => {
      if (window.cartCounterManager) {
        window.cartCounterManager.refreshCartCounter();
      }
    }, 1000);
  });
  
  // Handle cart page item removal
  jQuery(document).on('click', '.woocommerce-cart-form .product-remove .remove', function() {
    setTimeout(() => {
      if (window.cartCounterManager) {
        window.cartCounterManager.refreshCartCounter();
      }
    }, 1500);
  });
  
  // Handle WooCommerce blocks cart updates
  if (typeof wp !== 'undefined' && wp.data) {
    // Subscribe to cart store changes (WooCommerce Blocks)
    const unsubscribe = wp.data.subscribe(function() {
      if (window.cartCounterManager) {
        window.cartCounterManager.refreshCartCounter();
      }
    });
  }
  
  // Handle checkout updates
  jQuery('body').on('updated_checkout', function() {
    if (window.cartCounterManager) {
      window.cartCounterManager.refreshCartCounter();
    }
  });
});

// Custom Delivery Method Buttons Handler
document.addEventListener('DOMContentLoaded', () => {
  initializeDeliveryButtons();
});

function initializeDeliveryButtons() {
  // Handle delivery button clicks
  document.addEventListener('click', (e) => {
    if (e.target.closest('.delivery-button')) {
      e.preventDefault();
      const button = e.target.closest('.delivery-button');
      const methodId = button.getAttribute('data-method');
      
      if (methodId) {
        selectDeliveryMethod(button, methodId);
      }
    }
  });
  
  // Reinitialize after checkout updates
  jQuery(document.body).on('updated_checkout', () => {
    setTimeout(() => {
      initializeDeliveryButtons();
    }, 100);
  });
}

function selectDeliveryMethod(button, methodId) {
  // Remove selected class from all buttons
  const allButtons = document.querySelectorAll('.delivery-button');
  allButtons.forEach(btn => btn.classList.remove('selected'));
  
  // Add selected class to clicked button
  button.classList.add('selected');
  
  // Find and check the corresponding radio button
  const radioButton = document.querySelector(`input[value="${methodId}"].shipping_method`);
  if (radioButton) {
    radioButton.checked = true;
    
    // Trigger change event to update checkout
    jQuery(radioButton).trigger('change');
    
    // Update checkout totals
    jQuery('body').trigger('update_checkout');
    
    // Show loading state briefly
    button.style.opacity = '0.7';
    setTimeout(() => {
      button.style.opacity = '1';
    }, 500);
  }
}

// Handle checkout updates and maintain button states
jQuery(document.body).on('updated_checkout', () => {
  setTimeout(() => {
    // Sync button states with radio buttons
    const radioButtons = document.querySelectorAll('input.shipping_method');
    radioButtons.forEach(radio => {
      const button = document.querySelector(`.delivery-button[data-method="${radio.value}"]`);
      if (button) {
        if (radio.checked) {
          button.classList.add('selected');
        } else {
          button.classList.remove('selected');
        }
      }
    });
  }, 100);
});

// Order Success Popup Functionality
class OrderSuccessPopup {
  constructor() {
    this.popup = null;
    this.redirectTimer = null;
    this.init();
  }

  init() {
    // Listen for order completion events
    this.setupOrderCompletionListener();
  }

  setupOrderCompletionListener() {
    // Check for PHP-provided order success data
    if (typeof window.orderSuccessData !== 'undefined' && window.orderSuccessData.showPopup) {
      // Delay to ensure page is loaded
      setTimeout(() => {
        this.showOrderSuccessPopup(window.orderSuccessData.orderId, window.orderSuccessData);
      }, 500);
      return;
    }

    // Fallback: Check URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    const orderId = urlParams.get('order_id') || urlParams.get('key');
    
    if (orderId && (window.location.pathname.includes('/checkout/order-received/') || window.location.search.includes('order-received'))) {
      // Delay to ensure page is loaded
      setTimeout(() => {
        this.showOrderSuccessPopup(orderId);
      }, 500);
    }

    // Also listen for form submission completion (AJAX checkout)
    jQuery(document.body).on('checkout_place_order_success', (event, data) => {
      if (data && data.order_id) {
        this.showOrderSuccessPopup(data.order_id);
      }
    });

    // Listen for WooCommerce order completion events
    jQuery(document.body).on('wc_order_success', (event, data) => {
      if (data && data.order_id) {
        this.showOrderSuccessPopup(data.order_id);
      }
    });
  }

  showOrderSuccessPopup(orderId, orderData = null) {
    // Don't show popup if it already exists
    if (this.popup) {
      return;
    }

    // Create popup HTML
    this.createPopupHTML(orderId, orderData);
    
    // Show popup with animation
    setTimeout(() => {
      if (this.popup) {
        this.popup.classList.add('show');
      }
    }, 100);

    // Auto-redirect after 8 seconds unless user interacts
    // this.redirectTimer = setTimeout(() => {
    //   this.redirectToThankYou();
    // }, 8000);
  }

  createPopupHTML(orderId, orderData = null) {
    // Remove any existing popup
    const existingPopup = document.querySelector('.order-success-popup');
    if (existingPopup) {
      existingPopup.remove();
    }

    // Create popup element
    this.popup = document.createElement('div');
    this.popup.className = 'order-success-popup';
    
    // Get order number for display
    let orderNumber = orderId.toString().replace(/[^0-9]/g, '') || orderId;
    if (orderData && orderData.orderNumber) {
      orderNumber = orderData.orderNumber;
    }

    // Determine message based on pickup status
    let subtitle = 'Спасибо за ваш заказ. В ближайшее время с вами свяжется наш менеджер для уточнения деталей.';
    if (orderData && orderData.isPickup) {
      subtitle = 'Спасибо за ваш заказ! Самовывоз осуществляется в офисе партии по адресу: г. Москва, ул. Пятницкая, д.31. стр.2.';
    }
    
    this.popup.innerHTML = `
      <div class="popup-overlay"></div>
      <div class="popup-content">
        <button class="popup-close" aria-label="Закрыть">&times;</button>
        <div class="thankyou-icon"><img src="/wp-content/themes/yabloko_store/public/hands.png" alt="Thank you icon"></div>
        <h2 class="thankyou-title">Спасибо!</h2>
        <p class="thankyou-subtitle">В ближайшее время с вами свяжется наш менеджер и расскажет как получить заказ</p>
        <p class="thankyou-false-btn"> <img decoding="async" src="/wp-content/themes/yabloko_store/public/check.svg" alt="Check icon"> Заявка оформлена</p>
      </div>
    `;

    // Add to page
    document.body.appendChild(this.popup);

    // Add event listeners
    this.addEventListeners();
  }

  addEventListeners() {
    if (!this.popup) return;

    const overlay = this.popup.querySelector('.popup-overlay');
    const closeBtn = this.popup.querySelector('.popup-close');
    const detailsBtn = this.popup.querySelector('.continue-to-details');
    const shopBtn = this.popup.querySelector('.continue-shopping');

    // Close popup events
    overlay?.addEventListener('click', () => this.closePopup());
    closeBtn?.addEventListener('click', () => this.closePopup());

    // Action buttons
    detailsBtn?.addEventListener('click', () => {
      this.closePopup();
      this.redirectToThankYou();
    });

    shopBtn?.addEventListener('click', () => {
      this.closePopup();
      this.redirectToShop();
    });

    // ESC key to close
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.popup?.classList.contains('show')) {
        this.closePopup();
      }
    });
  }

  closePopup() {
    if (!this.popup) return;

    // Clear auto-redirect timer
    if (this.redirectTimer) {
      clearTimeout(this.redirectTimer);
      this.redirectTimer = null;
    }

    // Hide popup with animation
    this.popup.classList.remove('show');
    
    // Remove popup after animation
    setTimeout(() => {
      if (this.popup && this.popup.parentNode) {
        this.popup.remove();
        this.popup = null;
      }
    }, 300);
  }

  redirectToThankYou() {
    // If we're already on the thank you page, just close popup
    if (window.location.pathname.includes('/checkout/order-received/')) {
      this.closePopup();
      return;
    }

    // Otherwise redirect to current URL (which should be the thank you page)
    window.location.reload();
  }

  redirectToShop() {
    // Redirect to shop page
    let shopUrl = '/';
    
    if (typeof orderSuccessAjax !== 'undefined' && orderSuccessAjax.shop_url) {
      shopUrl = orderSuccessAjax.shop_url;
    } else if (typeof wc_add_to_cart_params !== 'undefined' && wc_add_to_cart_params.shop_url) {
      shopUrl = wc_add_to_cart_params.shop_url;
    }
    
    window.location.href = shopUrl;
  }
}

// Initialize Order Success Popup
document.addEventListener('DOMContentLoaded', () => {
  new OrderSuccessPopup();
});


document.addEventListener('DOMContentLoaded', () => {
    const phoneInputs = document.querySelectorAll('input[type="tel"]');
    phoneInputs.forEach((input) => {
      IMask(input, {
        mask: '+{7} (000) 000-00-00',
      });
    });
});